import { Outlet } from 'react-router-dom'
import { Box, CssBaseline } from '@mui/material'
import { motion } from 'framer-motion'

import Sidebar from './Sidebar'
import Topbar from './Topbar'
import Breadcrumbs from './Breadcrumbs'

const AppShell = () => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <CssBaseline />
      
      {/* Sidebar */}
      <Sidebar />
      
                        {/* Main Content */}
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      minHeight: '100vh',
                      width: { xs: '100%', md: 'auto' }
                    }}
                  >
        {/* Topbar */}
        <Topbar />
        
        {/* Breadcrumbs */}
        <Breadcrumbs />
        
                            {/* Page Content */}
                    <Box
                      component={motion.div}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      sx={{
                        flexGrow: 1,
                        p: { xs: 2, sm: 3 },
                        backgroundColor: 'background.default',
                        minHeight: 'calc(100vh - 120px)',
                        overflowX: 'auto'
                      }}
                    >
                      <Outlet />
                    </Box>
      </Box>
    </Box>
  )
}

export default AppShell
